import React, { useState, useEffect } from "react";

interface AjustorProps {
  onDrag: (deltaY: number) => void;
  onDragStart: (startY: number) => void;
}

const Ajustor: React.FC<AjustorProps> = ({ onDrag, onDragStart }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartY(e.clientY);
    onDragStart(e.clientY);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (isDragging) {
      const deltaY = e.clientY - startY;
      onDrag(deltaY);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, startY]);

  return (
    <div
      onMouseDown={handleMouseDown}
      style={{
        height: "4px",
        backgroundColor: isDragging ? "rgb(25, 118, 210)" : "rgb(207, 207, 207)",
        cursor: "ns-resize",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "background-color 0.2s",
        width: "100%"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "rgb(25, 118, 210)";
      }}
      onMouseLeave={(e) => {
        if (!isDragging) {
          e.currentTarget.style.backgroundColor = "rgb(207, 207, 207)";
        }
      }}
    >
      <div
        style={{
          width: "40px",
          height: "2px",
          backgroundColor: "white",
          borderRadius: "1px"
        }}
      />
    </div>
  );
};

export default Ajustor;
